import { useCallback, useSyncExternalStore } from 'react';
import { sound } from './engine';
import type { SoundName } from './synth';

/** React binding for the global sound engine (re-renders on mute/volume changes). */
export function useSound() {
  const settings = useSyncExternalStore(sound.subscribe, sound.getSettings, sound.getSettings);
  const play = useCallback((name: SoundName) => sound.play(name), []);
  const setMuted = useCallback((m: boolean) => sound.setMuted(m), []);
  const setVolume = useCallback((v: number) => sound.setVolume(v), []);
  const toggleMuted = useCallback(() => sound.toggleMuted(), []);
  return { play, muted: settings.muted, volume: settings.volume, setMuted, setVolume, toggleMuted };
}
